import React from 'react';
import { Box, Typography, Card, CardContent, Grid } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { ICompanyDetails } from '../../../redux/company/types';

interface ISalariesTab {
    companyDetails?: ICompanyDetails;
}

const SalariesTab: React.FC<ISalariesTab> = ({ companyDetails }) => {
    const { themeStyle } = useThemeContext();

    const designRoles = [
        { role: 'Junior Designer', salary: '$55K - $70K' },
        { role: 'Senior Designer', salary: '$75K - $95K' },
        { role: 'Art Director', salary: '$90K - $120K' },
        { role: 'Creative Director', salary: '$130K - $160K' },
    ];

    const uxRoles = [
        { role: 'UX Designer', salary: '$70K - $90K' },
        { role: 'Senior UX Designer', salary: '$90K - $120K' },
        { role: 'UI Designer', salary: '$65K - $85K' },
        { role: 'Product Designer', salary: '$85K - $110K' },
    ];

    return (
        <Card
            sx={{
                backgroundColor: theme[themeStyle].prisma_dark,
                border: `1px solid ${theme[themeStyle].tag_white_light}`,
                borderRadius: 2,
            }}>
            <CardContent sx={{ p: 3 }}>
                <Typography
                    variant="h6"
                    sx={{
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.BOLD_HEADER,
                        mb: 3,
                    }}>
                    Salary Information
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: theme[themeStyle].tag_white,
                                fontFamily: FONT_ENUM.BOLD_HEADER,
                                mb: 2,
                            }}>
                            Design Roles
                        </Typography>
                        <Box sx={{ spaceY: 2 }}>
                            {designRoles.map((role, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        p: 2,
                                        backgroundColor: theme[themeStyle].pure_black,
                                        borderRadius: 2,
                                        mb: 2,
                                    }}>
                                    <Typography
                                        sx={{
                                            color: theme[themeStyle].tag_white,
                                            fontFamily: FONT_ENUM.MEDIUM_TEXT,
                                            fontSize: '0.875rem',
                                        }}>
                                        {role.role}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: theme[themeStyle].tag_white,
                                            fontFamily: FONT_ENUM.MEDIUM_TEXT,
                                            fontWeight: 'medium',
                                        }}>
                                        {role.salary}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: theme[themeStyle].tag_white,
                                fontFamily: FONT_ENUM.BOLD_HEADER,
                                mb: 2,
                            }}>
                            UX/UI Roles
                        </Typography>
                        <Box sx={{ spaceY: 2 }}>
                            {uxRoles.map((role, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        p: 2,
                                        backgroundColor: theme[themeStyle].pure_black,
                                        borderRadius: 2,
                                        mb: 2,
                                    }}>
                                    <Typography
                                        sx={{
                                            color: theme[themeStyle].tag_white,
                                            fontFamily: FONT_ENUM.MEDIUM_TEXT,
                                            fontSize: '0.875rem',
                                        }}>
                                        {role.role}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: theme[themeStyle].tag_white,
                                            fontFamily: FONT_ENUM.MEDIUM_TEXT,
                                            fontWeight: 'medium',
                                        }}>
                                        {role.salary}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export { SalariesTab };
